import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const purposeDefinition: ResourceDefinition = {
  title: 'Purposes',
  nameSingular: 'Purpose',
  namePlural: 'Purposes',
  className: 'Purpose',
  mainIdentifier: 'name',
  slug: 'taxonomies/purposes',
  path: 'purposes',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (purpose) => ({
        type: ActionType.Link,
        link: {
          path: `${purposeDefinition.path}/${purpose.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (purpose) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: purpose,
          definition: purposeDefinition
        }
      })
    }
  ]
}
